import { Modal } from '@/components/Modal'
import { Content } from './Content'
import { modalId } from '../modalId'
import { ContextProvider } from './ContextProvider'
import { ModalPublicProps } from '../types'
import { ModalViewStateProvider } from './ModalViewStateProvider'

export function Root(props: ModalPublicProps) {
  return (
    <Modal modalId={modalId}>
      <ContextProvider {...props}>
        <ModalViewStateProvider>
          <Content />
        </ModalViewStateProvider>
      </ContextProvider>
    </Modal>
  )
}
